/* eslint-disable */
import React, { useState } from "react";
import { Box, Divider, Group, Title } from "@mantine/core";
import ChatApp from "./components/chatView/chatView";
import { useGetConversations } from "api/chat/getConversation";

// import SearchModal from "./components/search/search";
// import PunchOutModal from "./components/search/searchModal";

export default function Chat() {
  // const [opened, setOpened] = useState(false);

  return (
    <Box>
      <ChatApp />
      {/* <ChatAppSocket /> */}
      {/* <SearchModal opened={opened} onClose={() => setOpened(false)} /> */}
    </Box>
  );
}
